import { render, staticRenderFns } from "./WrapperMngt.vue?vue&type=template&id=b81ff53a"
import script from "./WrapperMngt.vue?vue&type=script&lang=js"
export * from "./WrapperMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports